import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as TilesetConfigActions from './tileset-config.actions';
import { Deserialize } from 'cerialize';
import { DifferentialTileset } from '../../models/differential-tileset';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../environments/environment';
import { TilesetConfig } from '../../models/tileset-config';
import { DatePipe } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';
import { SiteTools } from '../../tools/site.tools';
import {
  DifferentialTilesetTools
} from '../../tools/differential-tileset.tools';


@Injectable()
export class TilesetConfigEffects {

  loadTilesetConfigs$ = createEffect(() => {
    const activeLang = this.translocoService.getActiveLang();
    const datePipe: DatePipe = new DatePipe(activeLang);
    const dateFormat = (activeLang.startsWith('fr')) ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
    return this.actions$.pipe(ofType(TilesetConfigActions.loadTilesetConfigs),
      concatMap(({site}) =>
      this.api.differentialTilesets$(site.organization, site.id).pipe(
        map(differentialTilesets => differentialTilesets.flatMap((dt: any) => {
          const obj: DifferentialTileset = Deserialize(dt, DifferentialTileset);
          if (obj.batchComparedId != site.lastBatch) {
            return [];
          }
          const tilesUrl = DifferentialTilesetTools.tilesetUrl(site, obj);
          const tilesetConfig = new TilesetConfig(obj.id, obj.batchReferenceId, true, obj.maxDistance, tilesUrl);
          return tilesetConfig;
        })
        ),
        map(tilesetConfigs => {
          const pointCloudTilesUrl = SiteTools.pntsTilesetUrl(site, site.lastBatch);
          if (pointCloudTilesUrl) {
            const pointCloudTilesetConfig = new TilesetConfig("1", "pointcloud", true,  0, pointCloudTilesUrl);
            tilesetConfigs.unshift(pointCloudTilesetConfig);
          }
          const mainTilesUrl = SiteTools.modelTilesetUrl(site, site.lastBatch);
          if (mainTilesUrl) {
            const mainTilesetConfig = new TilesetConfig("0", "main", false, 0, mainTilesUrl);
            tilesetConfigs.unshift(mainTilesetConfig);
          }
          return tilesetConfigs;
        }),
        map(tilesetConfigs => TilesetConfigActions.loadTilesetConfigsSuccess({ tilesetConfigs })),
        catchError(error => of(TilesetConfigActions.loadTilesetConfigsFailure({ error }))))
    ));
  });

  addTilesetConfig$ = createEffect(() => {
    const activeLang = this.translocoService.getActiveLang();
    const datePipe: DatePipe = new DatePipe(activeLang);
    const dateFormat = (activeLang.startsWith('fr')) ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
    return this.actions$.pipe(ofType(TilesetConfigActions.addTilesetConfig),
      concatMap(({organizationId, siteId, batch_compared, batch_reference}) =>
        this.api.addDifferentialTileset$(organizationId, siteId, batch_compared, batch_reference).pipe(
          map(differentialTileset => {
            const obj: DifferentialTileset = Deserialize(differentialTileset, DifferentialTileset);
            const tilesUrl = (obj.maxDistance) ? environment.tilesUrl + "/" + obj.id + "/tileset.json" : undefined;
            const tilesetConfig = new TilesetConfig(obj.id, obj.batchReferenceId, true, obj.maxDistance, tilesUrl);
            return tilesetConfig;
          }),
          map(tilesetConfig => TilesetConfigActions.addTilesetConfigSuccess({ tilesetConfig })),
          catchError(error => of(TilesetConfigActions.addTilesetConfigFailure({ error }))))
      ));
  });

  constructor(private actions$: Actions, private api: ApiService, private translocoService: TranslocoService) {}

}
